import { Outlet } from 'react-router-dom'
import Footer from '../components/Footer'
import Header from '../components/header'
import { LayOut_Main } from '../styles/layout'

export function MainLayout() {
  return (
    <LayOut_Main>
      <Header />
      <Outlet />
    </LayOut_Main>
  )
}

export function LoginLayout() {
  return (
    <div>
      <main>
        <Outlet />
      </main>
    </div>
  )
}

export function AdminLayout() {
  return (
    <div>
      <Header />
      <main>
        <Outlet />
      </main>
    </div>
  )
}
